import { API_ROUTES } from '../../utils/constant';

export type ReportQuery = {
  type: number;
  startDate: string;
  endDate: string;
  teamIds?: string;
};

const getBaseEndpointByType = (type: number): string => {
  switch (type) {
    case 1:
      return API_ROUTES.report; // Period completed by tagger
    case 2:
      return API_ROUTES.report;
    default:
      return API_ROUTES.report;
  }
};

export const buildReportUrl = (q: ReportQuery) => {
  const base = getBaseEndpointByType(q.type);
  const params = new URLSearchParams();
  params.set('type', String(q.type));
  params.set('startDate', q.startDate);
  params.set('endDate', q.endDate);
  if (q.teamIds) params.set('teamIds', q.teamIds);
  return `${base}?${params.toString()}`;
};
